export default "__VITE_ASSET__056cc10a__"